const IndexadoresModule = {
    state: {
        indexadores: [],
        coresAtivos: [],
        ativos: []
    },
    getters: {
        getIndexadores(state) {
            if (!state.indexadores || state.indexadores.length <= 0) { // não possui indexadores carregados
                state.indexadores = [];
                // Os indexadores estão nos arquivos .env
                let indxes = '1;CDI|2;Ibovespa|3;Dolar Comercial|7;IPCA|2100105;Poupança'.split("|");

                for (let i = 0; i < indxes.length; i++) {
                    let dadosIndx = indxes[i].split(";");
                    state.indexadores.push({ codigoIndexador: dadosIndx[0], nomeIndexador: dadosIndx[1], selecionado: dadosIndx[1] === "CDI" });
                }
            }

            return state.indexadores;
        },
        getAtivos(state) {
            return state.ativos;
        },
        getSelecionados(state) {
            return state.indexadores.filter(el => el.selecionado);
        },
        getCoresAtivos(state) {
            return state.coresAtivos;
        },
    },
    mutations: {
        setIndexadores(state, indexadores) {
            state.indexadores = indexadores;
        },
        addAtivo(state, ativo) {
            // Não inserir o mesmo ativo mais de uma vez
            if (state.ativos.filter(a => a.value === ativo.value).length <= 0) {
                ativo.selecionado = true;
                state.ativos.push(ativo);
            }
        },
        removeAtivo(state, ativo) {
            state.ativos = state.ativos.filter(a => a.key !== ativo);
        },
        setSelecionados(state, indexadores) {
            state.indexadores.forEach(el => {
                el.selecionado = indexadores.includes(el.codigoIndexador);
            });
        },
        setCoresAtivos(state, cores) {
            state.coresAtivos = cores;
        },
        setQuantidadeAtivos(state, quantidade) {
            state.quantidadeAtivos = quantidade;
        },
    }
}

export default IndexadoresModule;